import React, { useState, useEffect, useCallback, useRef } from "react";
import { useParams } from "react-router-dom";
import { parseISO, format } from "date-fns";

import { HeaderTitle } from "../../../../components/HeaderTitle";
import {
  getManagementById,
  removeAnimalByManagement,
} from "../../../../services/management";
import { IManagementProps, RemoveAnimalByManagement } from "../../interfaces";
import { useNotification } from "../../../../hooks/useNotification";
import { biometricData, maintenance, others, restroomAndVet } from "../../data";
import { AboutManagement } from "../../../../components/AboutManagement";
import { useTranslate } from "../../../../hooks/useTranslate";
import { Stack } from "@mui/material";

const ViewManagement = () => {
  const { errorNotification } = useNotification();
  const params = useParams();
  const { translate } = useTranslate();

  const [loading, setLoading] = useState(true);
  const [management, setManagement] = useState<IManagementProps>(
    {} as IManagementProps
  );

  const boot = useCallback(
    async (id: string) => {
      try {
        setLoading(true);
        const management: IManagementProps = await getManagementById(id);

        const biometricFiltered = biometricData.filter((item) =>
          management.attributes.activity.includes(item.id)
        );
        const maintenanceFiltered = maintenance.filter((item) =>
          management.attributes.activity.includes(item.id)
        );
        const othersFiltered = others.filter((item) =>
          management.attributes.activity.includes(item.id)
        );
        const restroomAndVetFiltered = restroomAndVet.filter((item) =>
          management.attributes.activity.includes(item.id)
        );

        const allOptions = [
          ...biometricFiltered,
          ...maintenanceFiltered,
          ...othersFiltered,
          ...restroomAndVetFiltered,
        ].map((option) => option.label);

        setManagement({
          ...management,
          createdAtFormatted: format(
            parseISO(management.created_at),
            "dd/MM/yyyy ' - ' hh'h'mm"
          ),
          attributes: {
            ...management.attributes,
            activityFormatted: allOptions,
          },
        });
        setLoading(false);
      } catch {
        errorNotification(translate("management.not_found_results"));
      }
    },
    [errorNotification, translate]
  );

  const handleRemoveAnimal = async ({
    idAnimal,
    idManagement,
  }: RemoveAnimalByManagement) => {
    await removeAnimalByManagement({
      idAnimal,
      idManagement,
    });

    await boot(params.id!);
  };

  const ready = useRef(false);

  useEffect(() => {
    if (params.id && !ready.current) {
      ready.current = true;
      boot(params.id);
    }
  }, [params, boot]);

  if (loading) return <div />;

  return (
    <Stack spacing={3}>
      <HeaderTitle
        title={translate("management.title_view")}
        showIcon
        url="/managements"
      />
      <AboutManagement
        management={management}
        removeAnimal={handleRemoveAnimal}
      />
    </Stack>
  );
};

export { ViewManagement };
